// Cookie Consent UI Actions
export { InitializeCookieConsentAction } from './InitializeCookieConsentAction';
export { AcceptAllCookiesAction } from './AcceptAllCookiesAction';
export { AcceptNecessaryCookiesAction } from './AcceptNecessaryCookiesAction';
export { ManageCookieSettingsAction } from './ManageCookieSettingsAction';
export { SaveCookiePreferencesAction } from './SaveCookiePreferencesAction';

// Singleton instances
import { InitializeCookieConsentAction } from './InitializeCookieConsentAction';
import { AcceptAllCookiesAction } from './AcceptAllCookiesAction';
import { AcceptNecessaryCookiesAction } from './AcceptNecessaryCookiesAction';
import { ManageCookieSettingsAction } from './ManageCookieSettingsAction';
import { SaveCookiePreferencesAction } from './SaveCookiePreferencesAction';

export const initializeCookieConsentAction = new InitializeCookieConsentAction();
export const acceptAllCookiesAction = new AcceptAllCookiesAction();
export const acceptNecessaryCookiesAction = new AcceptNecessaryCookiesAction();
export const manageCookieSettingsAction = new ManageCookieSettingsAction();
export const saveCookiePreferencesAction = new SaveCookiePreferencesAction(); 